<template>
  <v-card>
    <v-toolbar flat>
      <b>Create or assign slide</b>
    </v-toolbar>
    <v-window v-model="step">
      <v-window-item :value="0">
        <div class="selector layout pa-3 justify-center align-center">
          <v-btn depressed @click="step = 1">
            Create
          </v-btn>
          <v-spacer />
          <div class="text-md-center">
            or
          </div>
          <v-spacer />
          <v-btn depressed disabled @click="step = 2">
            Assign
          </v-btn>
        </div>
      </v-window-item>
      <v-window-item :value="1">
        <div class="create">
          <add-slide-form :data="values" @data-dialog="onData" />
        </div>
      </v-window-item>
      <v-window-item :value="2">
        <div class="assign">
          <assign-slide-form :data="values" @data-dialog="onData" />
        </div>
      </v-window-item>
    </v-window>
    <v-card-actions v-if="step !== 0">
      <v-btn icon @click="step = 0">
        <v-icon>
          {{ icons.arrows.left }}
        </v-icon>
      </v-btn>
      <v-spacer />
      <v-btn depressed @click="$emit('close')">
        Cancel
      </v-btn>
      <v-btn :disabled="!canSubmit" :loading="isLoading" color="primary" depressed @click="submit">
        Save
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import AddSlideForm from '@/components/dialogs/forms/AddSlideForm';
import AssignSlideForm from '@/components/dialogs/forms/AssignSlideForm';
import { CREATE_SLIDE, SLIDES_UPDATE_ACTIVE } from '@/config/constants';
import icons from '../../mixins/icons';

export default {
  name: 'AddGroupSlideDialog',
  components: { AssignSlideForm, AddSlideForm },
  mixins: [icons],
  props: {
    type: {
      type: String,
      default: 'popup'
    },
    documentKey: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      step: 0,
      values: {},
      canSubmit: false,
      isLoading: false
    };
  },
  watch: {
    values(i, o) {
      this.canSubmit = !!((i.name !== '' && i.name) || i.slide);
    }
  },
  methods: {
    onData(values) {
      this.values = values;
    },
    submit() {
      switch (this.step) {
        case 1:
          if (!this.values.name || this.values.name === '' || !this.$store.state.slides.active._id) return;
          this.isLoading = true;
          return this.$store
            .dispatch(CREATE_SLIDE, {
              parents: [this.$store.state.slides.active._id],
              ...this.values,
              type: this.type
            })
            .then(r => {
              this.values = {};
              this.step = 0;
              this.isLoading = false;
              this.canSubmit = false;
              this.$emit('close');
            })
            .catch(err => {
              this.isLoading = false;
            });
        case 2:
          this.isLoading = true;
          return this.$store
            .dispatch(SLIDES_UPDATE_ACTIVE, { $addToSet: { [this.documentKey]: this.values.slide._id } })
            .then(() => {
              this.values = {};
              this.step = 0;
              this.isLoading = false;
              this.canSubmit = false;
              this.$emit('close');
            })
            .catch(err => {
              this.isLoading = false;
            });
      }
    }
  }
};
</script>

<style scoped></style>
